import { SteamItemType } from '@/entities/platforms/steam/types/types'
import { SteamUserDataType } from '@/entities/user'
import { useStyles } from './styles'
import { Spiner } from '@/shared/ui/spiner'

export const ItemsList = (props: Pick<SteamUserDataType, 'itemsList'>) => {
  const { itemsList } = props
  const { classes } = useStyles({})

  if (!itemsList) {
    return (
      <div className={classes.root}>
        {Array.from({ length: 6 }, (_, index) => (
          <div className={classes.listItem}>
            <Spiner
              key={index}
              size="s"
            />
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {itemsList.map((item, idx) => (
        <Item
          {...item}
          key={idx} // item.id is not unique
        />
      ))}
    </div>
  )
}

function Item(props: SteamItemType) {
  const { classes } = useStyles({})
  return (
    <div className={classes.listItem}>
      <img
        src={props.icon_url}
        alt={props.name}
        className={classes.img}
      />
    </div>
  )
}
